import { NLPSelfSender, ClipRenderProgress, ParticipantSelection } from './participantClipping.types';

export const participantSelection: ParticipantSelection = (participantId: string) => ({
  endpoint: `/participant-suggestion/${participantId}`,
  method: 'GET',
});

export const nlpSelfSenderTimes: NLPSelfSender = participantId => body => ({
  endpoint: `/nlp-util/self-render/${participantId}`,
  method: 'POST',
  body,
});

export const renderProgress: ClipRenderProgress = (participantId: string, renderStartTime: string) => ({
  endpoint: `/nlp-util/render-progress/${participantId}?renderStartTime=${renderStartTime}`,
  method: 'GET',
});
